var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5C16.8302 0.5 21.5 4.90243 21.5 10.2539C21.4999 12.4392 20.8386 14.8614 19.8203 17.2871C18.804 19.7081 17.4444 22.1025 16.0791 24.2236C14.7146 26.3435 13.3497 28.1825 12.3252 29.4912C11.8131 30.1453 11.3867 30.6665 11.0889 31.0234C11.0581 31.0603 11.0279 31.0946 11 31.1279C10.9721 31.0946 10.9419 31.0603 10.9111 31.0234C10.6133 30.6665 10.1869 30.1453 9.6748 29.4912C8.65027 28.1825 7.28542 26.3435 5.9209 24.2236C4.55556 22.1025 3.19601 19.7081 2.17969 17.2871C1.16145 14.8614 0.500067 12.4392 0.5 10.2539C0.5 4.90243 5.1698 0.5 11 0.5ZM12.8809 6.72266C11.9835 6.33773 10.9949 6.23714 10.041 6.43359C9.08717 6.6301 8.21335 7.1148 7.5293 7.82324C6.84547 8.53149 6.38116 9.43163 6.19336 10.4092C6.00562 11.3867 6.10206 12.4004 6.4707 13.3223C6.83938 14.2441 7.46478 15.035 8.27051 15.5928C9.07669 16.1507 10.0269 16.4502 11 16.4502H11.001C12.3056 16.4486 13.5528 15.9106 14.4697 14.9609C15.3861 14.0118 15.8989 12.7285 15.9004 11.3936V11.3926C15.9003 10.3963 15.6152 9.42086 15.0791 8.58984C14.5428 7.75855 13.7782 7.1076 12.8809 6.72266Z",
    fill: "#59B876",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4504,
    cy: 11.55,
    r: 6.05,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66028 13.8636L14.2574 9.19469C14.4691 8.97975 14.8157 8.97975 15.0274 9.19469C15.2344 9.40498 15.2344 9.74251 15.0274 9.95279L9.66028 15.4037L6.97381 12.6753C6.76675 12.465 6.76675 12.1275 6.97381 11.9172C7.18545 11.7022 7.5321 11.7022 7.74374 11.9172L9.66028 13.8636Z",
    fill: "#59B876"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletIcon1);
export default __webpack_public_path__ + "static/media/OutletIcon1.2f772bfbed1a6d73e1725c63d759e26c.svg";
export { ForwardRef as ReactComponent };